@if (productArgument().ID) {
  <li
    class="argument-list-item"
    (mouseenter)="isHovered.set(true)"
    (mouseleave)="isHovered.set(false)"
  >
    <article class="argument">
      <claas-argument-rating-icon
        [rating]="productArgument().Rating"
      ></claas-argument-rating-icon>
      <a [routerLink]="[`./detail/${productArgument().ID}`]" class="title">
        <h4 class="argument-title font-xs">{{ productArgument().Title }}</h4>
      </a>
      <div>
        @if (productArgument().Exclusive) {
          <div class="badge font-3xs">
            {{
              "features.productArguments.exclusiveFlag" | translate | uppercase
            }}
          </div>
        }
      </div>
      <button
        [attr.inert]="isFavourite() || isHovered() ? undefined : ''"
        (click)="addArgumentToFavorites(productArgument().ID)"
        [ngClass]="{
          'favorite-btn icon-only-button small': true,
          blacken: isFavourite(),
        }"
      >
        <claas-icon
          [id]="''"
          [iconId]="'649123'"
          [namespace]="'storybook'"
          [iconStyle]="'bold'"
          [size]="24"
          [alt]=""
          [iconName]="'favorites'"
          [removeDefaultColor]="true"
          [class]="'favorite-icon'"
        >
        </claas-icon>
      </button>
    </article>
  </li>
}
